import {BreadCrumb} from "@/components/BreadCrumb";
import PageHeaderName from "@/components/PageHeaderName/PageHeaderName";
import RenderToast from "@/components/RenderToast";
import Tooltip from "@/components/Tooltip";
import queryClient from "@/config/queryClient";
import {LogoutIcon, SingleUserIcon} from "@/constant/imagePath";
import {sidebarData} from "@/data/app-data";
import {signOutRequest} from "@/store/auth/authSlice";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

const flattenSidebar = (items) => {
  return items.flatMap((item) => [
    item,
    ...(item.submenu ? flattenSidebar(item.submenu) : []),
  ]);
};

export default function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const flattenedSidebar = flattenSidebar(sidebarData);
  const urlName = flattenedSidebar.find(
    (item) => item?.pagePath === location.pathname
  )?.name;

  const {user} = useSelector((state) => state?.authReducer);
  // need refactor ??
  const profileName =
    [user?.first_name || null, user?.last_name || null]
      .filter(Boolean)
      .join(" ") || "N/A";

  const logout = async () => {
    queryClient.clear();

    dispatch(signOutRequest());

    navigate("/");
    RenderToast({
      type: "success",
      message: `Successfully logout`,
    });
  };

  return (
    <div className="w-full pt-2.5 px-6 gap-y-1.5 flex flex-col">
      <div className="flex items-center justify-between">
        <BreadCrumb capitalizeLinks={true} separator={<>{">"}</>}/>
        <div className="flex items-center text-[#141218] gap-x-1 font-light">
          <img src={SingleUserIcon} alt="Single User Icon"/>
          <span>{profileName}</span>
          <Tooltip place="bottom" tooltipText="Logout">
            <button
              onClick={logout}
              className="flex items-center justify-center"
            >
              <img src={LogoutIcon} alt="Logout Icon"/>
            </button>
          </Tooltip>
        </div>
      </div>
      {urlName && <div>
        <PageHeaderName title={urlName}/>
      </div>}
    </div>
  );
}
